import { render } from "./CloneIcon.vue?vue&type=template&id=a065a79c&scoped=true"
const script = {}

import "./CloneIcon.vue?vue&type=style&index=0&id=a065a79c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a065a79c"]])

export default __exports__